import React, { useState } from 'react';
import { Modal } from 'antd';
import styles from './COAlertModal.module.scss';
import COButton from 'shared/components/COButton';
import { ButtonLabels, ButtonProps, ModalProps } from 'enums/COAlertModal';
import { ReactComponent as DeleteIcon } from 'assets/ColorIcons/SVG/group_58670.svg';
import { ReactComponent as EditIcon } from 'assets/ColorIcons/SVG/group_58671.svg';
import { ReactComponent as AlertIcon } from 'assets/ColorIcons/SVG/group_58672.svg';
import clsx from 'clsx';
import { modalCloseIcon } from '../OrganizationModal';

export interface COAlertModalProps {
  showModalState: boolean;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  onModalCancel?: () => void;
  deleteModal?: boolean;
  alertModal?: boolean;
  heading?: string;
  subHeading?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const COAlertModal: React.FC<COAlertModalProps> = ({
  showModalState,
  handleModalCancel,
  handleModalConfirm,
  deleteModal,
  alertModal,
  heading,
  subHeading,
  confirmLabel,
  cancelLabel,
  onModalCancel,
}: COAlertModalProps) => {
  const [Buttonloading, setButtonloading] = useState(false);

  const submitForm = async () => {
    setButtonloading(true);
    await handleModalConfirm();
    setButtonloading(false);
  };

  return (
    <Modal
      width={430}
      footer={
        deleteModal || alertModal
          ? [
              <div className={clsx(styles.buttonContainer, styles.paddingLeft)}>
                <COButton block onClick={handleModalCancel}>
                  {cancelLabel ? cancelLabel : ButtonLabels.CANCEL}
                </COButton>
              </div>,
              <div
                className={clsx(styles.buttonContainer, styles.paddingRight)}>
                <COButton
                  color={ButtonProps.COLOR}
                  secondary
                  loading={Buttonloading}
                  onClick={submitForm}>
                  {confirmLabel ? confirmLabel : ButtonLabels.DELETE}
                </COButton>
              </div>,
            ]
          : [
              <div className={clsx(styles.buttonContainer, styles.paddingLeft)}>
                <COButton onClick={submitForm} loading={Buttonloading}>
                  {ButtonLabels.CONFIRM}
                </COButton>
              </div>,
              <div
                className={clsx(styles.buttonContainer, styles.paddingRight)}>
                <COButton secondary block onClick={handleModalCancel}>
                  {ButtonLabels.CANCEL}
                </COButton>
              </div>,
            ]
      }
      title={ModalProps.EMPTY_STRING}
      okText={ModalProps.CONFIRM_TEXT}
      open={showModalState}
      wrapClassName={styles.modalContainer}
      closeIcon={modalCloseIcon}
      onCancel={onModalCancel ? onModalCancel : handleModalCancel}>
      {deleteModal ? <DeleteIcon /> : alertModal ? <AlertIcon /> : <EditIcon />}

      <h2>{heading}</h2>

      <p>{subHeading}</p>
    </Modal>
  );
};

export default COAlertModal;
